import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { LoadableTypography } from "@faire/retailer-visitor-shared/components/GhostLoading/LoadableTypography";
import { Row } from "@faire/web--source/slate/Layout";
import { getSlateIcon } from "@faire/web--source/slate/SlateMappings/getSlateIcon";
import { cn } from "@faire/web--source/tools/cn";
import { NoTranslate } from "@faire/web--source/ui/lib/localization";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import React from "react";

interface IBrandNameTextProps {
  brandToken: string | undefined;
  brandName: string | undefined;
  brandIcon?: IFaireIcon | undefined;
  isLoaded: boolean;
  addUnderline?: boolean;
}

export const BrandNameText: React.FC<IBrandNameTextProps> = ({
  brandToken,
  brandName,
  brandIcon,
  isLoaded,
  addUnderline = true,
}) => {
  const BrandIcon = getSlateIcon(brandIcon);

  const brandNameSection = (
    <Row align="center" gap="1/4x">
      {brandIcon ? (
        <div>
          <BrandIcon
            data-test-id="brand-icon"
            fontSize="12px"
            color={getSlateColorToken(brandIcon.color_token)}
            titleAccess=""
          />
        </div>
      ) : null}
      <LoadableTypography
        isLoaded={isLoaded}
        variant="paragraphSansRegular"
        maxLines={1}
        className="break-all"
      >
        <NoTranslate>
          <span>{brandName}</span>
        </NoTranslate>
      </LoadableTypography>
    </Row>
  );

  if (!brandToken) {
    return null;
  }
  return (
    <Row
      className={cn("overflow-hidden", { underline: addUnderline })}
      justify="space-between"
    >
      {brandNameSection}
    </Row>
  );
};
